module.exports = __webpack_public_path__ + "static/media/17@960w.c87da111.jpg";